import { SimpleBackgroundLayout } from "@feg/ui/src/common/layout/SimpleBackgroundLayout"
import { OpenInNew } from "@mui/icons-material"
import { Button, Card, CardContent, Container, Grid, Stack, Typography } from "@mui/material"
import { PropsWithChildren } from "react"

export function Root() {
  return (
    <SimpleBackgroundLayout>
      <Container
        maxWidth={"md"}
        sx={{
          overflowX: "auto"
        }}
      >
        <Stack
          sx={{
            gap: 4,
            paddingY: 4
          }}>
          <Stack
            direction={"row"}
            sx={{
              alignContent: "center",
              justifyContent: "center"
            }}>
            <Typography variant={"h1"} sx={{
              color: "primary.main"
            }}>
              HEA Digital
            </Typography>
          </Stack>
          <Grid container spacing={5} sx={{
            width: "100%"
          }}>
            <Grid
              size={{
                xs: 12,
                sm: 4
              }}
            >
              <LandingCard>
                <Typography variant={"h4"} align={"center"}>
                  Admin
                </Typography>
                <Typography variant={"body1"}>
                  The admin dashboard is where you can manage your projects, users and more.
                </Typography>
                <Button
                  href={"https://admin.headigital.com"}
                  target={"_blank"}
                  fullWidth
                  color={"primary"}
                  startIcon={<OpenInNew />}
                >
                  Open Admin
                </Button>
              </LandingCard>
            </Grid>
            <Grid
              size={{
                xs: 12,
                sm: 4
              }}
            >
              <LandingCard>
                <Typography variant={"h4"} align={"center"}>
                  Fieldbook
                </Typography>
                <Typography
                  variant={"body1"}
                  sx={{
                    flexGrow: 1,
                    minHeight: "0px"
                  }}>
                  For researchers to enter their projects and interviews.
                </Typography>
                <Button
                  href={"https://fieldbook.headigital.com"}
                  target={"_blank"}
                  fullWidth
                  color={"primary"}
                  startIcon={<OpenInNew />}
                >
                  Open Fieldbook
                </Button>
              </LandingCard>
            </Grid>
            <Grid
              size={{
                xs: 12,
                sm: 4
              }}
            >
              <LandingCard>
                <Typography variant={"h4"} align={"center"}>
                  Resolve
                </Typography>
                <Typography variant={"body1"} sx={{
                  flexGrow: 1
                }}>
                  For teamleader and admins to enter their projects and interviews.
                </Typography>
                <Button
                  href={"https://resolve.headigital.com"}
                  target={"_blank"}
                  fullWidth
                  color={"primary"}
                  startIcon={<OpenInNew />}
                >
                  Open Resolve
                </Button>
              </LandingCard>
            </Grid>
          </Grid>
        </Stack>
      </Container>
    </SimpleBackgroundLayout>
  );
}

function LandingCard({ children }: PropsWithChildren) {
  return (
    <Card
      elevation={10}
      sx={{
        height: "100%",
        backgroundColor: "background.paper"
      }}
    >
      <CardContent
        sx={{
          flex: 1,
          height: "100%",
          display: "flex",
          flexDirection: "column"
        }}
      >
        {children}
      </CardContent>
    </Card>
  )
}
